import React, { useState, useEffect } from "react";
import {
  AddItemToList,
  RemoveItemFromList,
  FAVORITES_ENDPOINT_ID,
} from "../../services/lists";
import "./index.scss";

const GetAriaLabelText = (isFavorited) => {
  return isFavorited ? "Remove from Favorites" : "Add to Favorites";
};

const GetButtonText = (isFavorited) => {
  return isFavorited ? "Favorited" : "Favorite";
};

const GetIcon = (isFavorited) => {
  return isFavorited ? "fa-star" : "fa-star-o";
};

const FavoriteButton = (props) => {
  const { className, iconOnly } = props;
  const [isFavorited, setIsFavorited] = useState(props.isFavorited);
  const [isProcessing, setIsProcessing] = useState(false);
  const [itemId, setItemId] = useState(props.itemId);

  useEffect(() => {
    if (props.itemId != itemId) {
      setItemId(props.itemId);
    }
  });

  useEffect(() => {
    const UpdateFavorite = () => {
      var updateSuccessful = false;
      if (isFavorited) {
        RemoveItemFromList(itemId, FAVORITES_ENDPOINT_ID)
          .then(() => {
            updateSuccessful = true;
          })
          .catch((err) => {
            console.log(
              "An error occurred. Unable to remove item from favorites list."
            );
          })
          .finally(() => {
            setIsProcessing(false);
            if (updateSuccessful)
              setIsFavorited(!isFavorited);
          });

      } else {
        AddItemToList(itemId, FAVORITES_ENDPOINT_ID)
          .then(() => {
            updateSuccessful = true;
          })
          .catch((err) => {
            console.log(
              "An error occurred. Unable to remove item from favorites list."
            );
          })
          .finally(() => {
            setIsProcessing(false);
            if (updateSuccessful)
              setIsFavorited(!isFavorited);
          });
      }
    };

    if (isProcessing && isFavorited !== undefined) UpdateFavorite();
  }, [isProcessing]);

  const updateFavoriteState = () => {
    if (!isProcessing) {
      setIsProcessing(true);
    }
  };

  return (
    <>
      {iconOnly ? (
        <button
          className={`fa ${GetIcon(isFavorited)} ${className}`}
          onClick={updateFavoriteState}
          disabled={isProcessing}
          data-favorited={isFavorited}
          aria-pressed={isFavorited}
          aria-label={GetAriaLabelText(isFavorited)}
        ></button>
      ) : (
          <button
            className={`favoriteButton typography-small ${className}`}
            onClick={updateFavoriteState}
            disabled={isProcessing}
            data-favorited={isFavorited}
            aria-pressed={isFavorited}
          >
            {GetButtonText(isFavorited)}
          </button>
        )}
    </>
  );
};

export { FavoriteButton };
